import { useMemo } from "react";

import { useBrandConfig } from "src/brand/config";
import { Status } from "src/core/constants/folders";
import { usePermissions } from "src/core/hooks/usePermissions";

export const useStatusFilter = () => {
  const { hasRole } = usePermissions();
  const brandConfig = useBrandConfig();

  const filteredStatuses = useMemo(() => {
    return brandConfig.foldersConfig
      .filter((config) => config.requiredGroups.some((role) => hasRole(role)))
      .map((config) => config.status);
  }, [brandConfig.foldersConfig, hasRole]);

  const hasAccessToStatus = (status: Status) => {
    return filteredStatuses.includes(status);
  };

  return {
    filteredStatuses,
    hasAccessToStatus,
  };
};
